const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

const adviceList = r => {
  require.ensure(
    [],
    () => r(require('@/modules/zkCdpPage/message/adviceList.vue')),
    'message'
  )
}
const announcement = r => {
  require.ensure(
    [],
    () => r(require('@/modules/zkCdpPage/message/announcement.vue')),
    'message'
  )
}

const settingsRouter = {
  path: '/message',
  name: 'message',
  component: Layout,
  meta: {
    id: '9ef73ec71857437e905a2b0b7337bb8e',
    auth: true
  },
  children: [
    {
      path: 'adviceList',
      name: 'adviceList',
      component: adviceList,
      meta: {
        id: '0d7096c4dd244902ba2e2b1177825b38',
        auth: true
      }
    },
    {
      path: 'announcement',
      name: 'announcement',
      component: announcement,
      meta: {
        id: 'e85b6c2050c44fccba3b2ab50fef0a04',
        auth: true
      }
    }
  ]
}
export default settingsRouter



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/message.js